export default function PoshLogo() {
  return (
    <a>
      <h1 className="text-4xl font-bold text-yellow-600 font-Play">POSH</h1>
    </a>
  );
}
